export default __webpack_public_path__ + "static/media/green-box.c62e255a.svg";